import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import PhoneLink from '../PhoneLink'

const CallKeithPopUp = ({ hidePopup }) => {
  const handleKeyPress = e => {
    switch (e.key) {
      case 'Escape':
        hidePopup()
        break
      default:
        break
    }
  }
  React.useEffect(() => {
    if (typeof window === 'undefined') return
    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [])

  return (
    <div className="fixed inset-0 z-[1000000]">
      <button
        onClick={hidePopup}
        className="fixed inset-0 bg-black opacity-50 backdrop-blur-sm -z-10"
      />
      <div className="absolute w-full top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] flex flex-col inset-0 h-screen xl:max-h-[80vh] xl:w-[50vw] animate-fade-in bg-blue-300 xl:overflow-hidden ">
        <button
          onClick={hidePopup}
          className="flex flex-row justify-center items-center gap-2 w-full xl:justify-end p-3 mt-8 md:mt-0"
        >
          <span className="text-sm xl:text-xl inline-block">CONTINUE SHOPPING {'-->'}</span>
          <div className=" size-8 2xl:size-12 2xl:text-xl border-2 border-black flex items-center justify-center rounded-full ">
            &#10005;
          </div>
        </button>
        <div className="w-full text-center gap-3 grow flex flex-col justify-between items-center py-5 lg:py-0">
          <div className="text-2xl 2xl:text-4xl font-bold text-black">
            MAKE A DEAL WITH
            <br />
            THE OWNER OF GRAY AND SONS!
          </div>
          <p className="text-xl 2xl:text-3xl font-normal max-w-[800px] ">
            Only Today, Sunday, April 28th <br />
            from 12:00PM to 4:00PM EST.
          </p>
          <div className="text-2xl ">
            BUY FROM <b>KEITH GRAY</b> DIRECTLY
          </div>
          <PhoneLink phone="(305) 209-0545" className="font-bold text-2xl 2xl:text-4xl">
            CALL OR TEXT <br className="lg:hidden" />
            &nbsp; (305) 209-0545
          </PhoneLink>
        </div>
        <div className=" shrink max-h-[50vh]">
          <StaticImage
            alt="Preowned certified rolex, used patek philippe watches, luxury cartier love bracelet"
            src={'../../images/keith-and-agnes-gray-pic.png'}
            loading="eager"
            placeholder="bg-blue-300 "
            imgStyle={{ objectFit: 'contain' }}
            className={'aspect-[2/1] w-full h-full'}
          />
        </div>
      </div>
    </div>
  )
}

export default CallKeithPopUp
